import React from 'react';
import { Link } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';

// Public AWS Policy Generator — helps users author valid AWS policy JSON
// (IAM / SCP-shaped documents: Version / Statement / Effect / Action / Resource).
export const AWS_POLICY_GENERATOR_URL = 'https://awspolicygen.s3.amazonaws.com/policygen.html';

/**
 * Small inline "Build with the AWS Policy Generator" link shown next to AWS
 * policy JSON entry fields to improve the authoring experience.
 *
 * Pass `sx` to control placement, e.g. `sx={{ ml: 'auto' }}` to sit flush-right
 * in a label row, or `sx={{ mt: 0.75 }}` to sit just below a field.
 */
function PolicyGeneratorLink({ sx = {}, label = 'Build with the AWS Policy Generator' }) {
  return (
    <Link
      href={AWS_POLICY_GENERATOR_URL}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.4,
        fontFamily: 'Metropolis, sans-serif',
        fontSize: '0.75rem',
        color: '#4698D3',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        '&:hover': { textDecoration: 'underline' },
        ...sx,
      }}
    >
      {label}
      <OpenInNewIcon sx={{ fontSize: 13 }} />
    </Link>
  );
}

export default PolicyGeneratorLink;
